import { MainWindow } from "@/components/layout/MainWindow";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/leads")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <MainWindow className="flex flex-col">
      <Outlet />
    </MainWindow>
  );
}
